import React from "react";
import { flagUrl, API_BASE } from "@/lib/api";

function resolveFlagSrc(flag) {
  if (!flag) return null;
  // If it's a URL (uploaded custom image) or absolute path
  if (flag.startsWith("http")) return flag;
  if (flag.startsWith("/api/")) return `${API_BASE.replace(/\/api$/, "")}${flag}`;
  // Otherwise treat as ISO country code → flagcdn
  return flagUrl(flag);
}

export default function Flag({ code, flag, flagImageUrl, size = 24 }) {
  const src = flagImageUrl ? resolveFlagSrc(flagImageUrl) : resolveFlagSrc(flag);
  if (!src) return <span className="font-mono-data text-xs">{code}</span>;
  return (
    <img
      src={src}
      alt={code || ""}
      width={size}
      height={size * 0.7}
      className="object-cover inline-block"
      style={{ width: size, height: size * 0.7 }}
      loading="lazy"
    />
  );
}
